import { render, staticRenderFns } from "./DashboardInProgress.vue?vue&type=template&id=5d007986&"
import script from "./DashboardInProgress.vue?vue&type=script&lang=js&"
export * from "./DashboardInProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports